import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function TermsAndConditions() {
    return (
        <div className="font-sans text-gray-800 bg-[#FAFCFF] flex flex-col min-h-screen">
            {/* TOP NAVIGATION */}
            <Navbar />

            {/* MAIN CONTENT AREA */}
            <main className="flex-grow w-full py-16 md:py-24">
                {/* Widened container to 1280px to align with the Navbar left-edge */}
                <div className="max-w-[1280px] mx-auto px-6 md:px-12">
                    
                    {/* PAGE HEADER - Removed text-center so it aligns left */}
                    <div className="mb-10 md:mb-12">
                        <h1 className="text-4xl md:text-5xl font-bold text-[#005AAC] mb-4 tracking-tight">
                            Terms & Conditions
                        </h1>
                        <p className="text-gray-500 text-lg">
                            Last updated: April 2026
                        </p>
                    </div>

                    <div className="bg-white p-8 md:p-12 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 max-w-5xl">
                        
                        <p className="text-gray-600 leading-relaxed mb-10 text-[16px]">
                            Welcome to <strong>wamglammz.com</strong> (“we,” “our,” “us”). These Terms and Conditions (“Terms”) govern your access to and use of our website. By using this website, you agree to be bound by these Terms. If you do not agree, please do not use our website.
                        </p>

                        <div className="space-y-8 text-[16px] text-gray-700 leading-relaxed">
                            
                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">1. Acceptance of Terms</h2>
                                <p>
                                    By accessing or using this website, you confirm that you have read, understood, and agree to comply with these Terms and all applicable laws and regulations.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">2. Changes to Terms</h2>
                                <p>
                                    We reserve the right to modify or replace these Terms at any time. Any changes will be posted on this page with an updated date. Continued use of the website after changes means you accept the revised Terms.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">3. Use of the Website</h2>
                                <p className="mb-3">
                                    You agree to use this website only for lawful purposes and in a manner that does not infringe the rights of others or restrict their use of the site.
                                </p>
                                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                                    <li>Do not engage in fraudulent, abusive, or illegal activity.</li>
                                    <li>Do not upload viruses, malware, or harmful code.</li>
                                    <li>Do not attempt to gain unauthorized access to the website.</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">4. User Accounts</h2>
                                <p>
                                    If you create an account on our website, you are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">5. Intellectual Property</h2>
                                <p className="mb-3">
                                    All content on this website, including text, images, graphics, logos, and designs, is the property of Wam Glammz or its licensors and is protected by intellectual property laws.
                                </p>
                                <p>
                                    You may not copy, reproduce, distribute, or exploit any content without our written permission.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">6. Products and Services</h2>
                                <p>
                                    All product descriptions, pricing, and availability are subject to change without notice. We reserve the right to refuse or cancel any order at our discretion.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">7. Limitation of Liability</h2>
                                <p>
                                    To the fullest extent permitted by law, Wam Glammz shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the website.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">8. Disclaimer</h2>
                                <p>
                                    This website is provided on an “as is” and “as available” basis without warranties of any kind, either express or implied.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">9. Third-Party Links</h2>
                                <p>
                                    Our website may contain links to third-party websites. We are not responsible for the content, policies, or practices of those websites.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">10. Termination</h2>
                                <p>
                                    We reserve the right to suspend or terminate your access to the website at any time, without notice, for violation of these Terms or for any other reason.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">11. Governing Law</h2>
                                <p>
                                    These Terms shall be governed by and interpreted in accordance with the laws of <strong>[Your Country/State]</strong>.
                                </p>
                            </section>

                        </div>
                    </div>
                </div>
            </main>

            {/* BOTTOM FOOTER */}
            <Footer />
        </div>
    );
}